import type { IIap } from '~/types/iap'

export const flattenFeatures = (value: IIap['unlockables']): string[] =>
  value
    ? Object.values(value).reduce((prev, curr) => {
        prev.push(...Object.values(curr).flat())
        return prev
      }, [] as string[])
    : []

export const getIapResourceType = (resourceId: string): 'iaps' | 'features' | 'packs' | undefined => {
  if (resourceId.includes('iaps')) {
    return 'iaps'
  }

  if (resourceId.includes('features')) {
    return 'features'
  }

  if (resourceId.includes('packs')) {
    return 'packs'
  }

  return undefined
}
